import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import ArchivePageNavigation from "archive/components/ArchivePageNavigation";
import { Row, Col } from "components/bootstrap";
import { DocumentTitle, PageHeader, Spinner } from "components/common";
import withParams from "routing/withParams";
import AppConfig from "util/AppConfig";
import ArchiveActions from "archive/ArchiveActions";
import { useArchiveBackend, saveArchiveBackend } from "archive/hooks/useArchiveBackends";
import ArchivePageHeaderSupport from "archive/components/ArchivePageHeaderDescription";
import ArchiveBackendConfigForm from "archive/components/ArchiveBackendConfigForm";
import useHistory from "routing/useHistory";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import { LICENSE_SUBJECTS } from "license/constants";
import LicenseCheck from "license/LicenseCheck";
import { ARCHIVE_LICENSE_WARNING_TITLE, ARCHIVE_LICENSE_WARNING_TEXT } from "archive/constants";
import ArchiveRoutes from "./Routes";
const isCloud = AppConfig.isCloud();
const StyledH2 = styled.h2`
  margin-bottom: 10px;
`;
const DEFAULT_BACKEND = {
  id: void 0,
  title: "",
  description: "",
  settings: {
    type: void 0
  }
};
const ArchiveBackendConfigurationPage = ({ params }) => {
  const { backendId } = params;
  const { t } = useTranslation("enterprise_archive");
  const history = useHistory();
  const sendTelemetry = useSendTelemetry("backend-configuration");
  const { data: fetchedBackend } = useArchiveBackend(backendId);
  const backend = backendId ? fetchedBackend : DEFAULT_BACKEND;
  if (isCloud) {
    history.push(ArchiveRoutes.BACKENDS.LIST);
  }
  const _isLoading = backendId && !(backend == null ? void 0 : backend.id);
  if (_isLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const _checkOutputPath = (path) => ArchiveActions.checkOutputTemplate(path);
  const _updateConfiguration = (backendUpdate) => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.ARCHIVE[`BACKEND_CONFIGURATION_${(backendUpdate == null ? void 0 : backendUpdate.id) ? "UPDATED" : "CREATED"}`], {
      app_pathname: "archive",
      event_details: { backend_type: backendUpdate.settings.type }
    });
    return saveArchiveBackend(backendUpdate).then(() => {
      history.push(ArchiveRoutes.BACKENDS.LIST);
    });
  };
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("archive_backend_configuration_page.document_title") }, /* @__PURE__ */ React.createElement(ArchivePageNavigation, null), /* @__PURE__ */ React.createElement(PageHeader, { title: t("archive_backend_configuration_page.page_title") }, /* @__PURE__ */ React.createElement(ArchivePageHeaderSupport, null)), /* @__PURE__ */ React.createElement(
    LicenseCheck,
    {
      text: t(ARCHIVE_LICENSE_WARNING_TEXT),
      title: t(ARCHIVE_LICENSE_WARNING_TITLE),
      licenseSubject: LICENSE_SUBJECTS.archive,
      displayWarningContainer: true,
      bsStyle: "danger"
    }
  ), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { lg: 8 }, /* @__PURE__ */ React.createElement(StyledH2, null, t("archive_backend_configuration_page.heading")), /* @__PURE__ */ React.createElement(
    ArchiveBackendConfigForm,
    {
      backend,
      checkOutputPath: _checkOutputPath,
      updateConfiguration: _updateConfiguration,
      submitButtonText: backendId ? t("archive_backend_configuration_page.update_backend") : t("archive_backend_configuration_page.create_backend"),
      submitLoadingText: backendId ? t("archive_backend_configuration_page.updating_backend") : t("archive_backend_configuration_page.creating_backend"),
      cancelURL: ArchiveRoutes.BACKENDS.LIST
    }
  ))));
};
export default withParams(ArchiveBackendConfigurationPage);
